// ================================
// ZBL TAG UTIL (JavaScript puro)
// ================================

// Normaliza (tira espaços e deixa maiúsculo)
export const normalizeZblInput = (s = "") =>
    s.trim().toUpperCase();

// Regex: número + tamanho no final
export const ZBL_TAG_REGEX = /^(\d+)(PP|P|M|GG|G|XGG)$/i;

// Faz o parse da etiqueta ZBL
// Retorna null se não for válida
export function parseZblTag(input) {
    const value = normalizeZblInput(input);
    const match = value.match(ZBL_TAG_REGEX);

    if (!match) return null;

    const [, numberPart, size] = match;

    return {
        raw: value,          // "17696PP"
        code: numberPart,    // "17696"
        size: size           // "PP"
    };
}

// Classifica o input
export function routeZblInput(input) {
    const zbl = parseZblTag(input);

    if (zbl) {
        return {
            type: "ZBL_TAG",
            ...zbl
        };
    }

    return {
        type: "FREE_TEXT",
        raw: input.trim()
    };
}
